import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/modules/spinner/spinner.service';

@Component({
  selector: 'app-broadcastings-broadcastings-card',
  templateUrl: './broadcastings-broadcastings-card.component.html',
  styleUrls: ['./broadcastings-broadcastings-card.component.scss']
})
export class BroadcastingsBroadcastingsCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  enableCount: any;
  disableCount: any;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) { }

  ngOnInit() { }

  ngAfterContentChecked() {
    this.spinnerService.show('broadcastings-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('broadcastings-counts-spinner');
      this.showCounter = true;
      this.enableCount = this.data.availableBroadcastings;
      this.disableCount = this.data.unavailableBroadcastings;
    } else if ('-' === this.data) {
      this.enableCount = '-';
      this.disableCount = '-';
      this.showCounter = true;
      this.spinnerService.hide('broadcastings-counts-spinner');
    }
  }

}
